import React from "react";
import styles from "./style.module.css";
import InputLabel from "../../../components/atoms/InputLabel";
import Button from "../../../components/atoms/Button";
import BlitzLogo from "../../../assets/images/blitz_logo.svg";
import HeadFoot from "../../common/HeadFoot";
import { useWhitelisting } from "../../../utils/hooks/useWhitelisting";
import { useState } from "react";
import Footer from "../../common/footerComponent";
import ModalForm from "../../../components/atoms/Modal";
import ReportMsgBox from "../../common/ReportMsg";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { verifyOtpAndAction } from "../../../utils/api";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
  setCompanyInfo,
  initiateApiCall,
} from "../../../store/actions/companyInfo";
import { searchAwb } from "../../../utils/api";
import { getAWBSuccess } from "../../../store/actions/awb";
import { getAWBFailure } from "../../../store/actions/awb";
import { Flip, toast } from "react-toastify";
import { setShowReport } from "../../../store/actions/companyInfo";
import "react-toastify/dist/ReactToastify.css";
import iconarchivebox from "../../../assets/images/ArchiveBox.svg"
import icon1 from "../../../assets/images/Group 19937.svg"
import icon2 from "../../../assets/images/PhoneX.svg"
import icon3 from "../../../assets/images/ThumbsDown.svg"
import icon4 from "../../../assets/images/DotsThreeOutlineVertical.svg"
import { useDetectSource } from '../../common/useDetectsource/usedetectsource';
import { ensureOtpSessionFor } from '../../../utils/otpSession';
import { REPORT_REASON_CLASS, errorCode, timer, track } from '../../../analytics';
import usePageView from '../../../analytics/usePageView';
const Report = () => {
  const param = useParams();
  // A saved OTP session belongs to one AWB: drop it when this page is for another one.
  ensureOtpSessionFor(param.awbInfo);
  const { isWhitelisted, trackingPageLogo: logo } = useWhitelisting();
  usePageView("report", { awb: param.awbInfo });
  const listData = [
    {
      id: "span4",
      list: "Misbehaviour/Misconduct",
      icon: icon1,
    },
    {
      id: "span8",
      list: "No pre-delivery contact",
      icon: icon2,
    },
    {
      id: "span5",
      list: "Refused doorstep delivery",
      icon: icon3,
    },
    {
      id: "span7",
      list: "Paid, but undelivered",
      icon: iconarchivebox,
    },
    {
      id: "span9",
      list: "Other Reasons",
      icon: icon4,
    },
  ];
  const [displayOtpPage, setotpPage] = useState(false);
    
    const [activeStatus, setActivestatus] = useState({ reschedule: true, cancel: false });
    const [fakeattempt , setfakeattempt] = useState(true);
    const {isComingFromWhatsApp, otp} = useDetectSource();
   
      const [reportmessagemodal, setreportmessagemodal] = useState(false);
      const[remark,setRemark] = useState("");
  const [showothers,setShowOthers]= useState(false);
    const [spanStyles,setSpanStyles] = useState({
      span1: {backgroundColor:"white", color:"#6E6E7A"},
      span2:{backgroundColor:"white" ,color:"#6E6E7A"},
      span3:{backgroundColor:"white", color:"#6E6E7A"},
      span4:{backgroundColor:"white" ,color:"#6E6E7A"},
      span5:{backgroundColor:"white" ,color:"#6E6E7A"},
      span6:{backgroundColor:"white" ,color:"#6E6E7A"},
      span7:{backgroundColor:"white" ,color:"#6E6E7A"},
      span8:{backgroundColor:"white" ,color:"#6E6E7A"},
      span9:{backgroundColor:"white" ,color:"#6E6E7A"},
    });
    const[disabled1,setDisabled1] = useState(true)
    const trackdata = useSelector((store) => store?.awbReducer?.data);
    console.log(trackdata,"kk");
    const [reschedule, setReschedule] = useState({
      name: "",
      number: "",
      address: "",
      pincode: "",
      city: "",
      state: "",
      date: "",
      time: "",
      address1:"",
      address2:"",
      deliveryInstruction:"",
      remarks:"",
    });

  const [text, setText] = useState("");
  const [selected, setSelected] = useState(false);
  const dispatch = useDispatch();

  const optionsToast = {
    position: toast.POSITION.BOTTOM_CENTER,
    transition: Flip,
    toastClassName: "toast",
    closeButton: false,
  };

  useEffect(() => {
    getAwb();
    setReschedule({
      ...reschedule,
      name:
        trackdata?.lastestAddress?.shippingAddress &&
        trackdata?.lastestAddress?.shippingAddress?.name,
      number:
        trackdata.lastestAddress?.shippingAddress &&
        trackdata?.lastestAddress?.shippingAddress?.msisdn,
      address:
        trackdata?.lastestAddress?.shippingAddress &&
        trackdata?.lastestAddress?.shippingAddress?.address,
      pincode:
        trackdata?.lastestAddress?.shippingAddress &&
        trackdata?.lastestAddress?.shippingAddress?.pinCode,
      city:
        trackdata?.lastestAddress?.shippingAddress &&
        trackdata?.lastestAddress?.shippingAddress?.city,
      state:
        trackdata?.lastestAddress?.shippingAddress &&
        trackdata?.lastestAddress?.shippingAddress?.state,
    });
  }, []);
  useEffect(() => {
    setSelected(false);
  }, []);

  console.log(selected, "result");
  const getAwb = async () => {
    let data;
    dispatch(initiateApiCall());
    data = await searchAwb(param.awbInfo);
    if (data.code === "200") {
      dispatch(setCompanyInfo(data?.result?.companyInfo));
      dispatch(getAWBSuccess("data", data?.result));
      console.log("ratinglog", data?.result?.ratingLog);
      // navigate(`/${param.awbInfo}`);
    } else {
      dispatch(getAWBFailure());
      toast.error("Something went wrong!!", optionsToast);
    }
  };
  console.log(showothers && remark === "", "hjk");
  console.log(remark === "" || !remark, "hjk2");
  console.log(showothers, "hjk3");

    const handlereport =async()=>{
     
      sessionStorage.setItem("validatereport",true);
      // Funnel: the reason in the support ticket subtype vocabulary (ticket_type, Last Mile).
      const reasonLabel = showothers ? "Other Reasons" : remark;
      const reason = { reason_class: REPORT_REASON_CLASS[reasonLabel] || "others", reason_label: reasonLabel, has_text: showothers && !!remark };
      track("tp_report", { step: "submitted", ...reason });
      const elapsed = timer();

     const response= await verifyOtpAndAction(
        reschedule,
        isComingFromWhatsApp ? otp: JSON.parse(sessionStorage.getItem("otp")),
        activeStatus,
        param.awbInfo,
        trackdata?.orderDetail?.[0]?.order,
        moment,
        trackdata?.orderDetail?.[0]?.suborder_id,
        setotpPage,
        fakeattempt
      );
      if (response?.code === "200") {
        track("tp_report", { step: "success", ...reason, elapsed_ms: elapsed() });
        setreportmessagemodal(true);
      } else {
        track("tp_report", { step: "failed", ...reason, code: errorCode(response), elapsed_ms: elapsed() });
      }
     
      dispatch(setShowReport(remark));
    //  handleReport();
  };

  const isMobileView = window.innerWidth < 600;
  const handleClick = (spanClass) => {
    setSelected(true);
    console.log(spanClass, "yes1");
    {
      spanClass === "span9" && setShowOthers(true);
    }
    {
      spanClass !== "span9" && setShowOthers(false);
    }

    const updatedSpanStyles = { ...spanStyles };
    for (const key in updatedSpanStyles) {
      if (key === spanClass) {
        console.log(key, "key");
        updatedSpanStyles[key] = {
          backgroundColor: "#01A831",
          color: "white",
        };
      } else {
        updatedSpanStyles[key] = {
          backgroundColor: "white",
          color: "#6E6E7A",
        };
      }
    }

    setSpanStyles(updatedSpanStyles);
    const instructionText = {
      span1: "Avoid ringing bell",
      span2: "Leave at the door",
      span3: "Leave with security",
      span4: "Misbehaviour/Misconduct",
      span5: "Refused doorstep delivery",
      span6: "Updated incorrect remarks",
      span7: "Paid, but undelivered",
      span8: "No pre-delivery contact",
      // span10: "Received payment, but shipment undelivered",
    };

    console.log("yes", instructionText["span1"]);
    console.log(instructionText[spanClass], "yes");
    setText(instructionText[spanClass]);

    setRemark((prevRemark) => {
      console.log(prevRemark, "previous remark");
      console.log(instructionText[spanClass], "new remark");
      return instructionText[spanClass];
    });
    // onChangeValue({
    //   target: {
    //     id: "remark",
    //     value:`${spanClass}`!="span4"? `${text}`:remark,
    //   },
    // });
    setReschedule((prevReschedule) => {
      console.log(prevReschedule, "previous reschedule");
      console.log(instructionText[spanClass], "new reschedule");

      return {
        ...prevReschedule,
        remarks: instructionText[spanClass],
      };
    });
  };
  console.log(reschedule, "remark");
  const onChangeValue = async (event) => {
    let id = event.target.id;
    if (id === "remark" && event.target && event.target.value !== undefined) {
      setRemark((prevRemark) => {
        console.log(prevRemark, "previous remark");
        console.log(event.target.value, "new remark");
        return event.target.value;
      });
      setReschedule({
        ...reschedule,
        remarks: event.target.value,
      });
      console.log(remark, "remark");
    }
  };
  console.log(showothers, remark, "showothers");
  // const length = remark?.length();
  // console.log(length,"l1")
  console.log(typeof remark !== "string" && !/^\s*$/.test(remark), "llo");

  console.log(remark === "", "llo2");

  const [active, setActive] = useState(false);
  const handleActive = (activeId) => {
    setActive(activeId.id);
  };
  return (
    <div className={styles.report_main}>
      <div class={styles.report_main_inner}>
        <HeadFoot logo={isWhitelisted ? logo : BlitzLogo} />
        <div className={styles.report_mobile_main}>
          <div class={styles.report_mobile}>
            <div class={styles.report_mobile_inner}>
              <h3>report</h3>
              <ul class={styles.report_mobile_list}>
                {listData.map((listinfo) => (
                  <li
                    className={`${active === listinfo.id ? styles.active : ""}`}
                    onClick={() => {
                      handleClick(listinfo.id);
                      handleActive(listinfo);
                    }}
                    key={listinfo.id}
                  >
                    <div>
                      <span>
                        <img
                          className={`${
                            active === listinfo.id ? styles.image : ""
                          }`}
                          src={listinfo.icon}
                        />
                      </span>
                      {listinfo.list}
                    </div>
                  </li>
                ))}
              </ul>
              {showothers && (
                <div className={styles.remark} style={{ marginTop: "1rem" }}>
                  <InputLabel
                    onChange={(event) => onChangeValue(event)}
                    paddingLeft={"0.5rem"}
                    paddingBottom={"4rem"}
                    height={"5"}
                    keyColor={"#6E6E7A"}
                    paddingTop={"0.1rem"}
                    borderRadius={7}
                    placeholder={"Write here"}
                    placeholderSize={"12px"}
                    id={"remark"}
                  />
                </div>
              )}
              <div
                style={{
                  marginTop: "1rem",
                  display: "flex",
                  justifyContent: "flex-end",
                  // marginRight:"35rem",
                }}
                className={styles.btn}
              >
                {reportmessagemodal && (
                  <ModalForm
                    isOpen
                    width={window.screen.availWidth < 600 ? "100%" : 350}
                    dimensionsUnit={"px"}
                    background={"#0A2A6B"}
                    noNavbar={true}
                    withCloseIcon={false}
                    close={() => setreportmessagemodal(false)}
                    onClose={() => setreportmessagemodal(false)}
                    renderContent={() => (
                      <ReportMsgBox
                        title1={"Order Cancelled"}
                        title2={"Your order has been cancelled"}
                        close={() => setreportmessagemodal(false)}
                      />
                    )}
                  ></ModalForm>
                )}

                <div
                  className={styles.submit_btn}
                  style={{ marginTop: "0.45rem", marginRight: "32.1%" }}
                >
                  <Button
                    minHeight={35}
                    text={"Submit"}
                    width={"17vh"}
                    height={"36px"}
                    padding={"0.5rem 1.25rem"}
                    opacity={
                      selected === false ||
                      ((remark === "" || !remark) && showothers)
                        ? 0.6
                        : 1
                    }
                    disabled={
                      selected === false ||
                      ((remark === "" || !remark) && showothers)
                        ? true
                        : false
                    }
                    // backgroundColor={"#0075FF"}
                    border={"none"}
                    backgroundColor={"#0066FF"}
                    color={"white"}
                    onclick={() => handlereport()}
                    // onclick={() => fetchOTP("ndr")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report;
